import React, { useState, useEffect } from 'react';

import LevelReport from '../../../Widgets/LevelReport';
import AdsMetrics from '../../../Widgets/AdsMetrics';
import GeneralVision from '../../../Widgets/GeneralVision';
import CampaignRange from '../../../Widgets/CampaignRange';
import GenderOrAgesPerformance from '../../../Widgets/GenderOrAgesPerformance';
import DevicePerformance from '../../../Widgets/DevicePerformance';
import Keywords from '../../../Widgets/Keywords';
import AdsGroups from '../../../Widgets/AdsGroups';

import SimpleLineChart from '../../../Widgets/charts/SimpleLineChart';
import SimpleBarChart from '../../../Widgets/charts/SimpleBarChart';
import PieChartWithCustomizedLabel from '../../../Widgets/charts/PieChartWithCustomizedLabel';
import Cards from '../../../Widgets/charts/Cards';
import BiaxialBarChart from '../../../Widgets/charts/BiaxialBarChart';

import TableDefault from '../../../Widgets/tables';

import Ads from '../../../Widgets/Ads';

import api from '../../../../services/api';

import { LoaderPdf } from '../../../Loader';

const DynamicReportTemplate = ({
	tag,
	data,
	captions,
	channel,
	title,
	keys,
	isLast,
	reportId,
	startDate,
	endDate,
}) => {
	const [loading, setLoading] = useState(true);
	const [chartData, setChartData] = useState(null);
	const [loader, setLoader] = useState(<LoaderPdf />);

	const components = {
		LevelReport,
		AdsMetrics,
		GeneralVision,
		CampaignRange,
		GenderOrAgesPerformance,
		DevicePerformance,
		AdsGroups,
		Keywords,
		SimpleLineChart,
		SimpleBarChart,
		PieChartWithCustomizedLabel,
		Cards,
		BiaxialBarChart,
		Ads,
		TableDefault,
	};

	const componentChartEnum = {
		cards_ads_metrics: 'Cards',
		line_clicks_impressions_daily: 'SimpleLineChart',
		bar_clicks_impressions_uf: 'BiaxialBarChart',
		pie_gender: 'PieChartWithCustomizedLabel',
		bar_gender_age: 'SimpleBarChart',
		pie_device: 'PieChartWithCustomizedLabel',
		card_devices: 'Cards',
	};

	const genderDefaultData = { name: loader, clicks: 4 };

	const dataChartEnum = {
		cards_ads_metrics: [
			{ title: 'Cliques', alias: 'Cliques', value: loader },
			{ title: 'Impressões', alias: 'Impressões', value: loader },
			{ title: 'CTR', alias: 'CTR', value: loader },
		],
		line_clicks_impressions_daily: [
			{ name: loader, impressions: 0, clicks: 0 },
		],
		bar_clicks_impressions_uf: [
			{ name: loader, clicks: 0, impressions: 0 },
		],
		pie_gender: [
			{ title: 'Homens', value: 1 },
			{ title: 'Mulheres', value: 1 },
		],
		bar_gender_age: Array(5).fill(genderDefaultData),
		pie_device: [
			{ title: 'Desktop', value: 1 },
			{ title: 'Mobile', value: 1 },
		],
		card_devices: [
			{
				title: 'Desktop',
				text: 'Visitas via Desktop',
				value: loader,
				alias: 'Desktop',
			},
			{
				title: 'Mobile',
				text: 'Visitas via Mobile',
				value: loader,
				alias: 'Mobile',
			},
		],
	};

	const validTag = tagName => components[tagName] !== undefined;

	const Chart = validTag(tag) && components[tag];

	const parseChartName = chart => chart
		.replace('_go_', '_')
		.replace('_face_', '_')
		.replace('_insta_', '_');


	useEffect(() => {
		const loadingRegex = {
			google: /\W*(\*\|GOOGLE_IMPRESSIONS\|\*)\W*|\W*(\*\|GOOGLE_CLICKS\|\*)\W*|\W*(\*\|GOOGLE_CTR\|\*)\W*/g,
			facebook: /^&/g,
			instagram: /^&/g,
		};

		data.content = {
			text: loading ? data.text.replace(loadingRegex[channel], ' ... ') : data.text,
		};

		data.charts = data.variables.charts.map(chart => ({
			channel,
			alias: chart,
			title: '',
			type: componentChartEnum[parseChartName(chart)],
			data: dataChartEnum[parseChartName(chart)],
		}));

		data.firstDate = startDate;
		data.lastDate = endDate;

		setChartData(data);
		setLoading(true);

		api.get(`/api/v2/reports/${reportId}/templates/${data.id}/charts?startDate=${startDate}&endDate=${endDate}`)
				.then((response) => {
					setLoading(false);
					setChartData({
						...data,
						variables: response.data.variables,
						content: response.data.content,
						tables: response.data.tables,
						charts: response.data.charts,
					});
				})
				.catch(() => {
					setLoading(false);
					setLoader('Nenhum dado encontrado');
				});
	}, [endDate]);

	return chartData && (
		<Chart
			data={chartData}
			captions={captions}
			typeChart={chartData.variables.component}
			alias={chartData.charts[0].alias}
			channel={channel}
			title={title}
			keys={keys}
			isLast={isLast}
		/>
	);
};

export default DynamicReportTemplate;
